function onlyLetters(onlyLetters) {
  let r = Math.random().toString(36).substr(2, 9);
  return onlyLetters ? r.replace(/[0-9]/g, "") : r;
}
export default onlyLetters;
